import { useLocation, Link } from "react-router-dom";
import axios from "../api/axios";
import { useRef, useState, useEffect } from "react";

const ResetPassword = () => {
    const passRef = useRef();
    const errRef = useRef();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    const [password, setPassword] = useState("");
    const [errMsg, setErrMsg] = useState("");

    useEffect(() => {
        passRef.current.focus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(
                "/reset-password",
                {email, token, password},
                {headers: {"Content-Type": "application/json"}}
            );
            setPassword("");
            setErrMsg("Your password has been updated.");
        } catch (err) {
            console.log(err);
            if (!err?.response) {
                setErrMsg("No Server Response");
            } else if (err.response?.status === 400) {
                setErrMsg("Missing Username or Password");
            } else if (err.response?.status === 401) {
                setErrMsg("Unauthorized");
            } else {
                setErrMsg("Request Failed");
            }
            errRef.current.focus();
        }
    }

    return (
        <section>
            <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            <h1>Sign In</h1>
            <form onSubmit={handleSubmit}>
                <label htmlFor="password">Password:</label>
                <input
                    type="password"
                    id="password"
                    ref={passRef}
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    required
                />
                <button>Submit</button>
            </form>
            <Link to="/login">Login</Link>
        </section>
    )
}

export default ResetPassword